import styled from '@emotion/styled/macro';
import React from 'react';
import {ThemeColors} from "../../layout/GlobalLayout";

const Label = styled.label`
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: ${ThemeColors.darkplatinum};


    & input {
      border: 1.5px solid #848484;
      border-radius: 4px;
      box-sizing: border-box;
      display: block;
      margin-top: 0.5rem;
      padding: 1rem 1.5rem;
      width: 100%;
      font-size: 1.5rem;
    
      background-color: ${ThemeColors.lightplatinum} ;
      color: ${ThemeColors.darkplatinum};
    }

    .tel {
      text-align: center;
    }
   
`

interface FormFieldProps {
    label?: string;
    name: string;
    onChange?: React.ChangeEventHandler;
    placeholder?: string;
    required?: boolean;
    type: React.HTMLInputTypeAttribute;
    value: string;
    pattern?: string;
}

export default function FormField({
    label,
    name,
    onChange,
    placeholder,
    required,
    type,
    value,
    pattern
}: FormFieldProps) {
    return (
        <Label htmlFor={name}>
            {label}
            <input
                className={type}
                id={name}
                name={name}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                type={type}
                value={value}
                pattern={pattern}
            />
        </Label>
    );
}
